import axios from "axios";
import { loginreq, req, reqPost } from "./axiosFun";

// 登录接口
export const login = params => {
  return loginreq("post", "/app-yijiu-backstage/login", params);
};

// 获取用户菜单
export const menu = params => {
  return axios
    .get("/api/menu?&token=" + localStorage.getItem("logintoken"))
    .then(res => res.data);
};
// 退出接口
export const loginout = () => {
  return axios
    .delete("/api/login?&token=" + localStorage.getItem("logintoken"))
    .then(res => res.data);
};

//用户管理
// 获取用户列表
export const getUserList = params => {
  return req("post", "/app-yijiu-backstage/getUserList", params);
};
export const getAuditSfzUserList = params => {
  return req("post", "/app-yijiu-backstage/getAuditSfzUserList", params);
};

export const authentication_x_q = params => {
  return req("post", "/app-yijiu-backstage/getAdminVerificationRecordList", params);
};

export const examineApi = params => {
  return req("post", "/app-yijiu-backstage/aduitVerification", params);
};

// 审核注册用户
export const aduitUser = params => {
  return req("post", "/app-yijiu-backstage/aduitUser", params);
};
// 禁用/启用用户
export const updateUserStatus = params => {
  return req("post", "/app-yijiu-backstage/updateUserStatus", params);
};
// 获取卡密列表
export const getCardList = params => {
  return req("post", "/app-yijiu-backstage/getCardList", params);
};
// 生成卡密
export const generateCards = params => {
  return req("post", "/app-yijiu-backstage/generateCards", params);
};
// 修改卡密
export const upCard = params => {
  return req("post", "/app-yijiu-backstage/upCard", params);
};
//提现记录管理列表
export const payoutsList = params => {
  return req("post", "/app-yijiu-backstage/payoutsList", params);
};
//审核提现
export const aduitPayout = params => {
  return req("post", "/app-yijiu-backstage/aduitPayout", params);
};
// 查询用户公司配置列表
export const getUserCompanyRecoordList = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getUserCompanyRecoordList?token=${localStorage.getItem(
        "logintoken"
      )}&userId=${params.userId}`,
      params
    )
    .then(res => res.data);
};
// 导出卡密列表
export const exportCardList = params => {
  return req("post", "/app-yijiu-backstage/exportCardList", params);
};

// 卡密批次管理
// 查询卡密批次列表
export const getCardBatchList = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getCardBatchList?token=${localStorage.getItem(
        "logintoken"
      )}`,
      params
    )
    .then(res => res.data);
};
// 查询卡密批次详情
export const getCardBatchInfo = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getCardBatchInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 添加卡密批次
export const addCardBatch = params => {
  return req("post", "/app-yijiu-backstage/addCardBatch", params);
};
// 删除卡密批次
export const deleteCardBatch = params => {
  return axios
    .delete(
      `http://118.195.249.109:446/app-yijiu-backstage/deleteCardBatch?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 修改卡密批次
export const upCardBatch = params => {
  return req("post", "/app-yijiu-backstage/upCardBatch", params);
};

//分类管理
export const getCategoryList = params => {
  return req("post", "/app-yijiu-backstage/getCategoryList", params);
};
export const addCategory = params => {
  return req("post", "/app-yijiu-backstage/addCategory", params);
};
export const upCategory = params => {
  return req("post", "/app-yijiu-backstage/upCategory", params);
};
export const deleteCategory = params => {
  return req("post", "/app-yijiu-backstage/deleteCategory", params);
};

// 附件商家 
export const merchantTypeApi = params => {
  return req("post", "/app-yijiu-backstage/addMerchantCategory", params);
};

export const merchantListApi = params => {
  return req("get", "/app-yijiu-backstage/getMerchantCategoryList", params);
};

export const modifyMerchantTypeApi = params => {
  return req("post", "/app-yijiu-backstage/upMerchantCategory", params);
};

export const delMerchantTypeApi = params => {
  return axios
  .get(
    `http://118.195.249.109:446/app-yijiu-backstage/deleteMerchantCategory?token=${localStorage.getItem(
      "logintoken"
    )}&id=${params.id}`,
    params
  )
  .then(res => res.data);
};


//轮播图管理
export const selectSlideshow = params => {
  return req("post", "/app-yijiu-backstage/selectSlideshow", params);
};
export const addSlideshow = params => {
  return req("post", "/app-yijiu-backstage/addSlideshow", params);
};
export const upSlideshow = params => {
  return req("post", "/app-yijiu-backstage/upSlideshow", params);
};
export const deleteSlideshow = params => {
  return req("post", "/app-yijiu-backstage/deleteSlideshow", params);
};

// 商品管理
// 查看商品列表
export const getCommodityList = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getCommodityList?token=${localStorage.getItem(
        "logintoken"
      )}&name=${params.name}&entity=${params.entity}&isDisable=${
        params.isDisable
      }&page=${params.page}`,
      params
    )
    .then(res => res.data);
};
// 查看商品详情
export const getCommodityInfo = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getCommodityInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 添加商品
export const addCommodity = params => {
  return req("post", "/app-yijiu-backstage/addCommodity", params);
};
// 删除商品
export const deleteCommodity = params => {
  return axios
    .delete(
      `http://118.195.249.109:446/app-yijiu-backstage/deleteCommodity?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 修改商品
export const upCommodity = params => {
  return req("post", "/app-yijiu-backstage/upCommodity", params);
};
// 调整商品库存
export const alterCommodityCount = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/alterCommodityCount?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}&type=${params.type}&count=${params.count}`,
      params
    )
    .then(res => res.data);
};

// 评价管理
// 查询所有作品评论
export const getPublishReplyList = params => {
  return req("post", "/app-yijiu-backstage/getPublishReplyList", params);
};
// 删除作品评论
export const deletePublishReplyList = params => {
  return axios
    .delete(
      `http://118.195.249.109:446/app-yijiu-backstage/deletePublishReplyList?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};

// 作品管理
// 查询所有作品
export const getPublishList = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getPublishList?token=${localStorage.getItem(
        "logintoken"
      )}&type=${params.type}&status=${params.status}&page=${
        params.page
      }&title=${params.title}&userName=${params.userName}`,
      params
    )
    .then(res => res.data);
};
// 审核通过
export const aduitAccessPublish = params => {
  return req("post", "/app-yijiu-backstage/aduitAccessPublish", params);
};
// 审核不通过
export const aduitNoAccessPublish = params => {
  return req("post", "/app-yijiu-backstage/aduitNoAccessPublish", params);
};
// 设置作品排序
export const setSort = params => {
  return req("post", "/app-yijiu-backstage/setSort", params);
};

// 活动服务接口
// 添加活动
export const addActivity = params => {
  return req("post", "/app-yijiu-backstage/addActivity", params);
};
// 删除活动
export const deleteActivity = params => {
  return axios
    .delete(
      `http://118.195.249.109:446/app-yijiu-backstage/deleteActivity?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 查询活动详情
export const getActivityInfo = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getActivityInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 查询活动列表
export const getActivityList = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getActivityList?token=${localStorage.getItem(
        "logintoken"
      )}&status=${params.status}&title=${params.title}&page=${params.page}`,
      params
    )
    .then(res => res.data);
};
// 查询活动报名用户列表
export const getActivityUserInfo = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getActivityUserInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}&page=${params.page}`,
      params
    )
    .then(res => res.data);
};
// 修改活动
export const upActivity = params => {
  return req("post", "/app-yijiu-backstage/upActivity", params);
};

// 用户反馈
export const responseFeedback = params => {
  return req("post", "/app-yijiu-backstage/responseFeedback", params);
};

export const getFeedback = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getFeedback?token=${localStorage.getItem(
        "logintoken"
      )}&keyword=${params.keyword}&page=${params.page}`,
      params
    )
    .then(res => res.data);
};

// 发布分类管理
// 添加发布
export const addPublishCategory = params => {
  return req("post", "/app-yijiu-backstage/addPublishCategory", params);
};
// 删除发布
export const deletePublishCategory = params => {
  return req("post", "/app-yijiu-backstage/deletePublishCategory", params);
};
// 查询发布
export const getPublishCategorysList = params => {
  return req("post", "/app-yijiu-backstage/getPublishCategoryList", params);
};
// 修改发布
export const upPublishCategory = params => {
  return req("post", "/app-yijiu-backstage/upPublishCategory", params);
};

// 放映厅管理
// 查询放映厅列表
export const getScreenRoomList = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getScreenRoomList?token=${localStorage.getItem(
        "logintoken"
      )}&name=${params.name}&categoryName=${params.categoryName}&page=${
        params.page
      }`,
      params
    )
    .then(res => res.data);
};
// 查询放映厅详情
export const getScreenRoomInfo = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getScreenRoomInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 添加放映厅
export const addScreenRoom = params => {
  return req("post", "/app-yijiu-backstage/addScreenRoom", params);
};
// 删除放映厅
export const deleteScreenRoom = params => {
  return axios
    .delete(
      `http://118.195.249.109:446/app-yijiu-backstage/deleteScreenRoom?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 修改放映厅
export const upScreenRoom = params => {
  return req("post", "/app-yijiu-backstage/upScreenRoom", params);
};
// 放映厅视频管理
// 查询放映厅视频列表
export const getScreenVideoList = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getScreenVideoList?token=${localStorage.getItem(
        "logintoken"
      )}&screenRoomName=${params.screenRoomName}&episodes=${
        params.episodes
      }&page=${params.page}`,
      params
    )
    .then(res => res.data);
};
// 查询放映厅视频详情
export const getScreenVideoInfo = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getScreenVideoInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 添加放映厅视频
export const addScreenVideo = params => {
  return req("post", "/app-yijiu-backstage/addScreenVideo", params);
};
// 删除放映厅视频
export const deleteScreenVideo = params => {
  return axios
    .delete(
      `http://118.195.249.109:446/app-yijiu-backstage/deleteScreenVideo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 修改放映厅视频
export const upScreenVideo = params => {
  return req("post", "/app-yijiu-backstage/upScreenVideo", params);
};
// 放映厅购买
// 查询放映厅购买列表
export const getScreenBuyList = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getScreenBuyList?token=${localStorage.getItem(
        "logintoken"
      )}&mobile=${params.mobile}&screenName=${params.screenName}&page=${
        params.page
      }`,
      params
    )
    .then(res => res.data);
};

// 金字塔管理
// 查询金字塔列表
export const getPyramidList = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getPyramidList?token=${localStorage.getItem(
        "logintoken"
      )}`,
      params
    )
    .then(res => res.data);
};
// 查询金字塔详情
export const getPyramidInfo = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getPyramidInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 添加金字塔
export const addPyramid = params => {
  return req("post", "/app-yijiu-backstage/addPyramid", params);
};
// 删除金字塔
export const deletePyramid = params => {
  return axios
    .delete(
      `http://118.195.249.109:446/app-yijiu-backstage/deletePyramid?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 修改金字塔
export const upPyramid = params => {
  return req("post", "/app-yijiu-backstage/upPyramid", params);
};

// 圈层管理
// 查询圈层列表
export const getCirclesList = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getCirclesList?token=${localStorage.getItem(
        "logintoken"
      )}`,
      params
    )
    .then(res => res.data);
};
// 查询圈层详情
export const getCirclesInfo = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getCirclesInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 添加圈层
export const addCircles = params => {
  return req("post", "/app-yijiu-backstage/addCircles", params);
};
// 删除圈层
export const deleteCircles = params => {
  return axios
    .delete(
      `http://118.195.249.109:446/app-yijiu-backstage/deleteCircles?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 修改圈层
export const upCircles = params => {
  return req("post", "/app-yijiu-backstage/upCircles", params);
};
// 查询申请圈层列表
export const getApplyCirclesList = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getApplyCirclesList?token=${localStorage.getItem(
        "logintoken"
      )}&status=${params.status}&userName=${params.userName}&circlesId=${
        params.circlesId
      }&page=${params.page}`,
      params
    )
    .then(res => res.data);
};
// 审核申请圈层列表
export const aduitApplyCircles = params => {
  return req("post", "/app-yijiu-backstage/aduitApplyCircles", params);
};
// 查询用户圈层列表详情//放在用户列表中
export const getUserCirclesList = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getUserCirclesList?token=${localStorage.getItem(
        "logintoken"
      )}&userId=${params.userId}`,
      params
    )
    .then(res => res.data);
};
// 开通圈层//放在用户列表中
export const openCircles = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/openCircles?token=${localStorage.getItem(
        "logintoken"
      )}&userId=${params.userId}&circlesId=${params.circlesId}`,
      params
    )
    .then(res => res.data);
};

// 课程管理
// 查询课程列表
export const getTaskList = params => {
  return req("post", "/app-yijiu-backstage/getTaskList", params);
};
// 查询课程详情
export const getTaskInfo = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getTaskInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 发布课程
export const addTask = params => {
  return req("post", "/app-yijiu-backstage/addTask", params);
};
// 审核课程
export const aduitTask = params => {
  return req("post", "/app-yijiu-backstage/aduitTask", params);
};
// 删除课程
export const deleteTask = params => {
  return axios
    .delete(
      `http://118.195.249.109:446/app-yijiu-backstage/deleteTask?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 修改课程
export const upTask = params => {
  return req("post", "/app-yijiu-backstage/upTask", params);
};
// 查询课程参与用户列表
export const getUserListByTaskId = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getUserListByTaskId?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}&page=${params.page}`,
      params
    )
    .then(res => res.data);
};

// 课程视频管理
// 查看课程视频列表
export const getAdminTaskRoomList = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getAdminTaskRoomList?token=${localStorage.getItem(
        "logintoken"
      )}&taskId=${params.taskId}&page=${params.page}`,
      params
    )
    .then(res => res.data);
};
// 查看课程视频详情
export const getAdminTaskRoomInfo = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getAdminTaskRoomInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 添加课程视频
export const addAdminTaskRoom = params => {
  return req("post", "/app-yijiu-backstage/addAdminTaskRoom", params);
};
// 删除课程视频
export const deleteAdminTaskRoom = params => {
  return axios
    .delete(
      `http://118.195.249.109:446/app-yijiu-backstage/deleteAdminTaskRoom?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 修改课程视频
export const upAdminTaskRoom = params => {
  return req("post", "/app-yijiu-backstage/upAdminTaskRoom", params);
};

// 课程标签管理
// 查询课程标签管理列表
export const getTaskTagList = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getTaskTagList?token=${localStorage.getItem(
        "logintoken"
      )}`,
      params
    )
    .then(res => res.data);
};
// 查询课程标签详情
export const getTaskTagInfo = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getTaskTagInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 添加课程标签管理
export const addTaskTag = params => {
  return req("post", "/app-yijiu-backstage/addTaskTag", params);
};
// 删除课程标签管理
export const deleteTaskTag = params => {
  return axios
    .delete(
      `http://118.195.249.109:446/app-yijiu-backstage/deleteTaskTag?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 修改课程标签管理
export const upTaskTag = params => {
  return req("post", "/app-yijiu-backstage/upTaskTag", params);
};

// 订单管理接口
// 查询订单列表
export const getOrderList = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getOrderList?token=${localStorage.getItem(
        "logintoken"
      )}&mobile=${params.mobile}&status=${params.status}&orderNumber=${
        params.orderNumber
      }&page=${params.page}`,
      params
    )
    .then(res => res.data);
};
// 去发货
export const tryPost = params => {
  return req("post", "/app-yijiu-backstage/tryPost", params);
};

// 充值记录
// 查询充值记录列表
export const getAdminBalanceList = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getAdminBalanceList?token=${localStorage.getItem(
        "logintoken"
      )}&userName=${params.userName}&mobile=${params.mobile}&status=${
        params.status
      }&payWay=${params.payWay}&page=${params.page}`,
      params
    )
    .then(res => res.data);
};
// 查询用户钱包余额明细列表 type 0 新增 1 扣除
export const getUserBalanceList = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getUserBalanceList?token=${localStorage.getItem(
        "logintoken"
      )}&type=${params.type}&page=${params.page}&userName=${
        params.userName
      }&mobile=${params.mobile}`,
      params
    )
    .then(res => res.data);
};

// 拉新配置管理

// 查询拉新配置列表
export const getPullNewList = params => {
  return axios
    .get(
      `http://118.195.249.109:446/app-yijiu-backstage/getPullNewList?token=${localStorage.getItem(
        "logintoken"
      )}`,
      params
    )
    .then(res => res.data);
};
// 添加拉新配置
export const addPullNew = params => {
  return req("post", "/app-yijiu-backstage/addPullNew", params);
};
// 删除拉新配置
export const deletePullNew = params => {
  return axios
    .delete(
      `http://118.195.249.109:446/app-yijiu-backstage/deletePullNew?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 修改拉新配置
export const upPullNew = params => {
  return req("post", "/app-yijiu-backstage/upPullNew", params);
};
// 查询是否需要审核
export const getAduitStatus = params => {
  return req("post", "/app-yijiu-backstage/getAduitStatus", params);
};
//配置审核
export const setAduitStatus = params => {
  return req("post", "/app-yijiu-backstage/setAduitStatus", params);
};
//删除作品列表
export const dePublishByAdmin = params => {
  return req("post", "/app-yijiu-backstage/dePublishByAdmin", params);
};
// 添加权限
export const addRoles = params => {
  return req("post", "/app-yijiu-backstage/addRoles", params);
};

export const upRoles = params => {
  return req("post", "/app-yijiu-backstage/upRoles", params);
};

export const deleteRoles = params => {
  return req("post", "/app-yijiu-backstage/deleteRoles", params);
};

export const getRolesList = params => {
  return req("post", "/app-yijiu-backstage/getRolesList", params);
};

export const upAdminRole = params => {
  return req("post", "/app-yijiu-backstage/upAdminRole", params);
};

// 用户管理-获取用户列表
export const getAdminList = params => {
  return req("post", "/app-yijiu-backstage/getAdminList", params);
};
export const addAdmin = params => {
  return req("post", "/app-yijiu-backstage/addAdmin", params);
};
export const upAdmin = params => {
  return req("post", "/app-yijiu-backstage/upAdmin", params);
};
export const deleteAdmin = params => {
  return req("post", "/app-yijiu-backstage/deleteAdmin", params);
};
export const aduitSfz = params => {
  return req("post", "/app-yijiu-backstage/aduitSfz", params);
};
export const getIndexData = params => {
  return loginreq("POST", "/app-yijiu-backstage/getIndexData", params);
};

 
export const addTax = params => {
  return req("POST", "/app-yijiu-backstage/addTax", params);
};

export const upTax = params => {
  return req("POST", "/app-yijiu-backstage/upTax", params);
};

export const getTaxInfo = params => {
  return req("get", "/app-yijiu-backstage/getTaxInfo", params);
};

export const getTaskPrice = params => {
  return req("POST", "/app-yijiu-backstage/getTaskPrice", params);
};
export const upAdminTaskPrice = params => {
  return req("POST", "/app-yijiu-backstage/upAdminTaskPrice", params);
};
//查询当前版本
export const getVersion = params => {
  return req("GET", "/app-yijiu-backstage/getVersion", params);
};

//修改版本
export const upVersion = params => {
  return loginreq("GET", "/app-yijiu-backstage/upVersion", params);
};
// export const upVersion = params => {
//   return axios
//     .delete(
//       `http://118.195.249.109:446/app-yijiu-backstage/upVersion?token=${localStorage.getItem(
//         "logintoken"
//       )}&id=${params.version}`,
//     )
//     .then(res => res.data);
// };
 


// WEBPACK FOOTER //
// ./src/api/userMG.js